export default "__VITE_ASSET__IT6JpQE1__"